export { default } from './DonatiuMarato';
export type { DonatiuMaratoProps } from './DonatiuMarato.types';
